/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
'use memo';
import React from 'react';
import cx from 'classnames';
import styles from '../styles.module.scss';
import azCommonStyles from '../../../../theme/globals.module.scss';

type Props = {
  className?: string;
};

const BreadcrumbSeparator = ({ className }: Props) => {
  return (
    <span className={cx(azCommonStyles['az-caption'], styles['breadcrumb-separator'], className)}>
      {'\u2215'}
    </span>
  );
};

export default BreadcrumbSeparator;
